export default "__VITE_ASSET__BeY1HElE__"